import { render, staticRenderFns } from "./popup-elements.vue?vue&type=template&id=60de7d0e&"
import script from "./popup-elements.vue?vue&type=script&lang=js&"
export * from "./popup-elements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports